var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashBin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.332 23.438a2.286 2.286 0 0 0-2.285 2.285v16.148a2.285 2.285 0 0 0 4.57 0V25.723a2.285 2.285 0 0 0-2.285-2.285Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 0C14.327 0 0 14.327 0 32c0 17.673 14.327 32 32 32 17.673 0 32-14.327 32-32C64 14.327 49.673 0 32 0Zm13.711 20.39v25.29a4.57 4.57 0 0 1-4.57 4.57H22.859a4.57 4.57 0 0 1-4.57-4.57V20.39a3.047 3.047 0 1 1 0-6.093h6.225c.404 0 .791-.16 1.077-.446l2.155-2.155a1.524 1.524 0 0 1 1.077-.446h6.355c.404 0 .791.16 1.077.446l2.154 2.155c.287.285.674.446 1.078.446h6.224a3.047 3.047 0 0 1 0 6.094Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.668 23.438a2.285 2.285 0 0 0-2.285 2.285v16.148a2.285 2.285 0 0 0 4.57 0V25.723a2.286 2.286 0 0 0-2.285-2.285Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBin);
export default __webpack_public_path__ + "static/media/trash-bin.c90cd77d3a09280e011ccf23656d6971.svg";
export { ForwardRef as ReactComponent };